<template>
    <section class="content">
        <div class="row">
            <div class="col-md-6">

                <div class="box box-primary">

                    <div class="box-header with-border">
                        <div class="box-title">
                            Modifica dati personali
                        </div>
                    </div>

                    <div class="box-body box-profile">
                        <form v-on:submit.prevent="updateProfile" data-vv-scope="profile">
                            <div class="form-group" v-bind:class="{'has-error': errors.has('name')}">
                                <label for="name">Nome e cognome</label>
                                <input v-validate="'required'" type="text" class="form-control" id="name" name="name"
                                       v-model="profile.name">
                                <span v-show="errors.has('name')"
                                      class="help-block">Devi inserire il nome</span>
                            </div>

                            <div class="form-group" v-bind:class="{'has-error': errors.has('email')}">
                                <label for="email">Email</label>
                                <input v-validate="'required|email'" type="email" class="form-control" id="email"
                                       name="email"
                                       v-model="profile.email">
                                <span v-show="errors.has('email')"
                                      class="help-block">Devi inserire un'email valida</span>
                            </div>

                            <button class="btn btn-primary btn-block">
                                <i class="fa fa-circle-o-notch fa-spin" v-if="loaderProfile"></i>
                                Salva
                            </button>
                        </form>

                    </div>
                </div>

                <div class="box box-primary">

                    <div class="box-header with-border">
                        <div class="box-title">
                            Modifica password
                        </div>
                    </div>

                    <div class="box-body box-profile">

                        <form v-on:submit.prevent="password" data-vv-scope="password">
                            <div class="form-group" v-bind:class="{'has-error': errors.has('newPassword')}">
                                <input v-validate="'required'" type="password" class="form-control" id="newPassword"
                                       name="newPassword" v-model="newPassword"
                                       placeholder="nuova password">
                                <span v-show="errors.has('newPassword')"
                                      class="help-block">Devi inserire la password</span>
                            </div>

                            <div class="form-group" v-bind:class="{'has-error': errors.has('newPasswordRepeat')}">
                                <input v-validate="'required|confirmed:newPassword'" type="password"
                                       class="form-control"
                                       id="newPasswordRepeat" name="newPasswordRepeat" v-model="newPasswordRepeat"
                                       placeholder="ripeti password">
                                <span v-show="errors.has('newPasswordRepeat')"
                                      class="help-block">Le due password non coincidono</span>
                            </div>

                            <button class="btn btn-primary btn-block
">
                                <i class="fa fa-circle-o-notch fa-spin" v-if="loaderPassword"></i>
                                Salva nuova password
                            </button>
                        </form>

                    </div>
                </div>

            </div>
        </div>
    </section>
</template>

<script>
  import types from '../store/mutation-types'

  export default {
    name: 'profile',

    data () {
      return {
        loaderProfile: false,
        loaderPassword: false,
        newPassword: null,
        newPasswordRepeat: null
      }
    },

    beforeCreate () {
      if (typeof this.$store.state.profile.profile === undefined) {
        this.$router.replace('/')
      }
    },

    computed: {
      profile () {
        return _.cloneDeep(this.$store.state.profile.profile)
      }
    },

    created () {
      this.$store.commit(types.SET_HEADER_STATE, {
        pageTitle: 'Profilo',
        createButton: false
      })
    },

    methods: {
      updateProfile () {
        this.$validator.validateAll('profile')
          .then((result) => {
            if (result) {
              this.loaderProfile = true
              this.$store.dispatch('updateProfile', this.profile)
                .then((response) => {
                  toastr.success('Profilo modificato correttamente')
                  this.loaderProfile = false
                })
            } else {
              toastr.error('Sono presenti errori nel form')
            }
          })
      },
      password () {
        this.$validator.validateAll('newPassword')
          .then((result) => {
            if (result) {
              this.loaderPassword = true
              this.$store.dispatch('password', this.newPassword)
                .then((response) => {
                  toastr.success('Password modificata correttamente')
                  this.loaderPassword = false
                })
            } else {
              toastr.error('Sono presenti errori nel form')
            }
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Profile.vue